export const getWelcomeMessageText = (intl, hour) => {
    const { $t } = intl;
    let message;
    if (hour < 12)
        message = $t({
            id: 'Greetings.Morning',
            defaultMessage: 'Good morning',
        });
    else if (hour < 18)
        message = $t({
            id: 'Greetings.Afternoon',
            defaultMessage: 'Good afternoon',
        });
    else
        message = $t({
            id: 'Greetings.Evening',
            defaultMessage: 'Good evening',
        });
    return message;
};
//# sourceMappingURL=utils.js.map